import React, { useState } from 'react'
import Modal from "react-bootstrap/Modal";
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useAuthContext } from '../../../hooks';
import { approveCompOffByCm } from '../../../api/Compoff/approve_comp_off';
const ModalComp = ({ data, fetchUser }: any) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const {
      register,
      handleSubmit,
      reset,
  
      formState: { errors },
    } = useForm();
    const auth = useAuthContext();
    let email: any = [data?.applied_by_email];

    console.log(data,"data is here see this ")
    const approveEPto = async (e: any) => {
      console.debug("data > ", e);
      await approveCompOffByCm(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        {
          ...e,
          org_user_id: data?.org_user_id,
          // p_name: data?.approver_name,
          p_email: email,
          p_start_date: data?.start_date,
          p_end_date: data?.end_date,
          p_duration: data?.duration,
          p_reason: data?.reason,
          p_id: data?.id,
          p_name: data?.applied_by_name,
          p_leave_type_id:data?.leave_type_id
        }
      )
        .then((e) => {
          console.log(e);
        })
        .catch((err) => {
          console.log("====================================");
          console.log(err);
          console.log("====================================");
        });
      console.log(e);
    };
    const onSubmit = async (e: any) => {
      console.log("I am Here", e);
      await approveEPto(e);
      reset();
      setShow(false);
      fetchUser();
    };
    let str = data?.e_s3_url;
    str = str?.replace(/^\{'|'\}$/g, '');
  return (
    
<>

<Button
        variant="primary"
        onClick={() => {
          handleShow();
        }}
        className="leave-button"
        // style={{ width: "150px", height: "20px", display: "flex", jus }}
      >
        Take Action
      </Button>
     
      <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Leave Application</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <label>Employee Name:</label>
              {data?.applied_by_name}{" "}
            </div>
            <div>
              <label>Reason:</label>
              {data?.reason}
            </div>
            <div>
              <label>Duration:</label>
              {data?.duration < 1
                ? `${data?.duration} hours`
                : ` ${data?.duration} days`}
            </div>
            <div>
              <label>Star Date:</label>
              {data?.start_date}
            </div>
            <div>
              <label>End Date:</label>
              {data?.end_date}
            </div>


            <div>
<label>Reporting Manager's Actions :</label>
{data?.status}d
            </div>
            <a href={str} download={str}>Click to download the document</a>
            <label>Country Manager Action:</label>
            <Form.Select
              aria-label="Default select example"
              {...register("p_status", {
                required: { value: true, message: "This is required" },
              })}
            >
              <option value="">Choose option</option>

              <option value="approve">Approve</option>
              <option value="decline">Decline</option>
            </Form.Select>

            <Button variant="primary" type="submit">
              Approve
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

</>


  )
}

export default ModalComp

